import { useLocale } from "@lib/i18n/navigation-pages-router";
import { defaultLocale } from "@lib/i18n/config";
import { useCurrentUser } from "@hooks/use-current-user";
import Image from "@components/core/Image";
import staticSitesEntryPoint from "@utils/constants/staticSitesEntryPoint";
import SectionProgressBar from "./SectionProgressBar";

function TunnelStepsLayoutHeader({ currentSectionNumber, currentStepNumber }) {
  const locale = useLocale();
  const user = useCurrentUser();

  const homeUrl = user
    ? `${locale !== defaultLocale ? `/${locale}` : ""}/home`
    : `${process.env.NEXT_PUBLIC_CUSTOMER_WEBSITE}${staticSitesEntryPoint[locale]}`;

  return (
    <nav className="border-bottom tunnel-steps-layout">
      <a
        href={homeUrl}
        className="my-auto"
      >
        <Image
          src="logo"
          style={{ height: "1.5rem", maxWidth: "120px" }}
        />
      </a>

      <div className="sections-container">
        <SectionProgressBar
          sectionNumber={0}
          sectionLastStepNumber={2}
          currentSectionNumber={currentSectionNumber}
          currentStepNumber={currentStepNumber}
        />
        <SectionProgressBar
          sectionNumber={1}
          sectionLastStepNumber={4}
          currentSectionNumber={currentSectionNumber}
          currentStepNumber={currentStepNumber}
        />
        <SectionProgressBar
          sectionNumber={2}
          sectionLastStepNumber={6}
          currentSectionNumber={currentSectionNumber}
          currentStepNumber={currentStepNumber}
        />
      </div>
    </nav>
  );
}

export default TunnelStepsLayoutHeader;
